import '.bz{flex-shrink:0;}.ssr-plugin'
import '.c0{padding:1rem;}.ssr-plugin'
import '.a2{width:100%;}.ssr-plugin'
import '.be{height:100%;}.ssr-plugin'
import '.bi{border:none;}.ssr-plugin'
import '.bj{background-color:transparent;}.ssr-plugin'
import '.g9{border-radius:0px;}.ssr-plugin'
import '.g{display:flex;}.ssr-plugin'
import '.h{flex-direction:column;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.df{position:sticky;}.ssr-plugin'
import '.ga{top:4rem;}.ssr-plugin'
import '.gb{z-index:7;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.gc{padding-bottom:1rem;}.ssr-plugin'
import '.a5{margin-bottom:1rem;}.ssr-plugin'
import '.gd{border-bottom:var(--blue-border);}.ssr-plugin'
import '.r{position:fixed;}.ssr-plugin'
import '.cu{top:0;}.ssr-plugin'
import '.bc{left:0px;}.ssr-plugin'
import '.bd{right:0px;}.ssr-plugin'
import '.ge{bottom:0px;}.ssr-plugin'
import '.fe{z-index:9999;}.ssr-plugin'
import '.gf{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.ct{justify-content:flex-end;}.ssr-plugin'
import '.c1{flex:1;}.ssr-plugin'
import '.ar{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="bz c0 a2 be bi bj g9"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="g h ab"
    >
      <div className="df ga gb ae gc a5 gd g"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="r cu bc bd ge fe ae gf g h"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="c0 g ct gd"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="c1 ar">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
